<template>
  <div class="section-header" :class="classObject">
    <h2 data-aos="fade-up" data-aos-duration="600" class="section-title">
      {{ title }}
    </h2>
    <div
      data-aos="fade-up"
      data-aos-duration="600"
      data-aos-delay="400"
      class="section-subcaption"
      v-if="subcaption && subcaption !== ''"
    >
      <p>
        {{ subcaption }}
      </p>
    </div>
    <div
      data-aos="fade-up"
      data-aos-duration="600"
      data-aos-delay="400"
      class="section-description"
      v-if="description && description !== ''"
    >
      <p v-html="description" />
    </div>
  </div>
</template>

<script>
export default {
  name: "SectionHeader",
  props: {
    title: {
      type: String,
      default: "Section Title"
    },
    description: {
      type: String
    },
    subcaption: {
      type: String
    },
    extraClass: {
      type: [String, Array]
    }
  },
  computed: {
    classObject() {
      return this.extraClass ? this.extraClass : "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variable.scss";
.section-header {
  text-align: center;
  margin-bottom: 60px;
  .section-title {
    font-family: $heading-font;
    font-size: 42px;
    font-weight: 400 !important;
    color: #d73228;
    letter-spacing: 2px !important;
    text-transform: uppercase;
    margin: 0 !important;
  }
  .section-subcaption {
    p {
      font-family: $content-font;
      font-size: 16px;
      font-weight: 600;
      color: #212164;
      margin: 10px 0 0 0 !important;
    }
  }
  .section-description {
    p {
      font-family: $content-font;
      font-size: 16px;
      font-weight: 400;
      max-width: 700px;
      color: #707070;
      margin: 10px auto 0 !important;
    }
    ul {
      li {
        font-family: $content-font;
        font-size: 14px;
        font-weight: 400;
        max-width: 700px;
        color: #707070;
        padding-bottom: 10px;
        &:last-child {
          padding: 0;
        }
      }
    }
  }
  &.text-left {
    text-align: left;
    .section-description {
      p {
        margin-left: 0 !important;
        max-width: 100%;
      }
    }
  }
  &.text-white {
    .section-title {
      color: #fff;
    }
    .section-subcaption {
      p {
        color: #fff;
      }
    }
    .section-description {
      p {
        color: #fff;
      }
    }
  }
  &.no-margin {
    margin-bottom: 0;
  }
}

@media only screen and (max-width: 991px) {
  .section-header {
    margin-bottom: 50px;
    .section-title {
      font-size: 36px;
      line-height: 44px;
    }
    .section-subcaption {
      p {
        font-size: 14px;
      }
    }
    .section-description {
      p {
        font-size: 14px;
      }
      ul {
        li {
          font-size: 12px;
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .section-header {
    margin-bottom: 40px;
    .section-title {
      font-size: 32px;
      line-height: 40px;
    }
  }
}

@media only screen and (max-width: 575px) {
  .section-header {
    .section-title {
      font-size: 28px;
      line-height: 36px;
    }
    .section-description {
      ul {
        li {
          font-size: 12px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
